import React from "react";
import {Stack, Typography} from "@mui/material";
import {useTranslations} from "next-intl";

interface SubmissionProps {
  error?: boolean;
}

const NeedMoreInfoSubmissionMessage = ({
  error = false
}: SubmissionProps) => {
  const t = useTranslations("FORMS");
  return (
    <Stack
      sx={{
        display: "flex",
        width: "100%",
        alignItems: "center",
        textAlign: "center",
        gap: "2.4rem",
        padding: "4rem"
      }}
    >
      <Typography
        variant="h2"
        component="h5"
        data-testid="need-more-info-submission-message-header"
      >
        {error ? t("There was an issue") : t("Thank You")}
      </Typography>
      <Typography
        variant="subtitle1"
        component="p"
        data-testid="need-more-info-submission-message-copy"
      >
        {error ? t("NEED_MORE_INFO.error message") : t("NEED_MORE_INFO.submission copy")}
      </Typography>
    </Stack>
  );
};

export default NeedMoreInfoSubmissionMessage;